/**
 * Colors_T1.jsx
 */

export const mapB2CTenantToLanding = (tenantData) => {
  const theme = tenantData?.theme || {};
  const topBar = tenantData?.topBar || {}; // ⭐ Ensure we capture this object
  const header = tenantData?.header || {};
  const footer = tenantData?.footer || {};
  const hero = tenantData?.hero || {};

  return {
    companyId:       tenantData?.companyId,
    branchId:        tenantData?.branchId, 
    userId:          tenantData?.userId,
    logoUrl:         tenantData?.branding?.logoUrl || '/assets/images/logo.png',
    brandName:       tenantData?.branding?.brandName || 'Travel Agency',
    email:           tenantData?.branding?.email || 'support@agency.com',
    phones:          Array.isArray(tenantData?.branding?.phones) ? tenantData?.branding?.phones[0] : tenantData?.branding?.phones || '9128341203',
    whatsapp:        tenantData?.branding?.whatsapp || '9128341203',
    socials:         tenantData?.branding?.socials || {},

    themeColor1:     theme.themeColor1 || theme.themecolor1, 
    themeColor2:     theme.themeColor2 || theme.themecolor2,
    themeColor3:     theme.themeColor3 || theme.themecolor3,
    themeColor4:     theme.themeColor4 || theme.themecolor4,
    themeColor5:     theme.themeColor5 || theme.themecolor5,

    // ⭐ SECTIONAL MAPPING
    topBarBg:        topBar.bgColor   || theme.themeColor1 || theme.themecolor1,
    topBarText:      topBar.textColor || '#ffffff',


    headerBg: header.bgColor || theme.themeColor3 || "#ffffff",
headerText: header.textColor || "#111111",

    footerBg:        footer.bgColor   || theme.themeColor2 || theme.themecolor2 || '#1a1a1a',
    footerText:      footer.textColor || '#ffffff',

    // ⭐ HERO MODULE DATA
    heroData: {
        
        holidays: {
            title:    hero.holidays?.title    || "Find Your Perfect Trip.",
            subTitle: hero.holidays?.subTitle || "Search deals on homes.",
            textColor: hero.holidays?.textColor || "#ffffff", // ⭐ Fixed path
            bgImage:  hero.holidays?.bgImage  || "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?q=80&w=2073",
        },
    }
  };
};

export const getB2CColors_T1 = (landingData) => {
  const c1 = landingData.themeColor1 || "#F4B400";   // Gold Primary

  return {
    theme1: c1,

    theme2: landingData.footerBg || "#0B1F3A",       // Navy Footer
    theme3: landingData.headerBg || "#FFFFFF",       // White Header
    theme4: landingData.themeColor4 || "#F5F7FA",    // Soft Gray Section
    theme5: landingData.themeColor5 || "#0B1F3A",    // Dark Text

    headerText: landingData.headerText || "#111111",
    footerText: landingData.footerText || "#FFFFFF",

    topBarBg: landingData.topBarBg || "#0B1F3A",     // Dark top bar
    topBarText: landingData.topBarText || "#FFFFFF",
  };
};